import './index.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
// App
import App from 'app/App';
// Service
import StorageService from 'services/Storage.service';
// Store
import store from 'store';
// // i18n
// import './i18n';

StorageService.getDataFromUrl();

const slug = StorageService.getSlug();

// import reportWebVitals from './reportWebVitals';

const { href } = window.location;
const routeIndex = href.includes('/live-leaderboard') ? href.includes('/quiz-group/') ? 2 : 1 : 0

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <Provider store={store}>
      <MemoryRouter
        initialEntries={[`/quiz/${slug}`, `/quiz/${slug}/live-leaderboard`, `/quiz-group/${slug}/live-leaderboard`]}
        initialIndex={routeIndex}
      >
        <App />
      </MemoryRouter>
    </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
